/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React, { Component } from 'react';

/*  Components  */
import CoverPage from '../Components/Containers/CoverPage';

/*  Reports  */
import Overview from './Reports/Overview';

/*  State  */
const state = () => ({
    loaded: false
});

class PartnerUsersReport extends Component {
    constructor(props) {
        super(props);
        this.state = state();
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        const { reportData } = this.props;

        if (!reportData) {
            return;
        }

        this.setState({ loaded: true });
    };

    render() {
        const { reportData, reportSetup, renderingScheduledReport } =
            this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <Box>
                {reportSetup.reportSelections
                    ?.partnerUsersPartnerUsersCover && (
                    <CoverPage reportSetup={reportSetup} />
                )}
                <Box style={{ margin: '32px' }}>
                    <Overview
                        data={reportData}
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                    />
                </Box>
            </Box>
        );
    }
}

export default PartnerUsersReport;
